<template>
  <span
    class="headimg"
    :style="{width:size+'px',height:size+'px',backgroundImage:'url('+imgUrl+')'}"
  ></span>
</template>

<script>
export default {
  components: {},
  props: {
    size: {
      type: Number,
      default: 50
    },
    src: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      imgUrl: ""
    };
  },
  watch: {
    src(newVal) {
      if (newVal) {
        this.imgUrl = newVal;
      } else {
        this.imgUrl = require("@/assets/phone.jpg");
      }
    }
  },
  computed: {},
  methods: {},
  created() {
    if (this.src) {
      this.imgUrl = this.src;
    } else {
      this.imgUrl = require("@/assets/phone.jpg");
    }
  },
  mounted() {}
};
</script>
<style  scoped lang="scss">
.headimg {
  border-radius: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  display: inline-block;
}
</style>